module.exports = __webpack_public_path__ + "static/media/br.7118606b.svg";